import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ClientServices } from '../../@theme/services/clients.service';
import { FilterService } from '../../@theme/services/filter.service';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
@Component({
  selector: 'gd-accountreport',
  template: `
    <div id="print-content" style="padding:10px;">
      <table width="100%" style="font-size:12px; border-collapse: collapse;">
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Rep Name:
          </td>
          <td>{{ RepNamInfo.repName }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Client Name:
          </td>
          <td>{{ RepNamInfo.clientName }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Account Name:
          </td>
          <td>{{ RepNamInfo.accountName }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Date Received:
          </td>
          <td>{{ RepNamInfo.dateReceived | date : 'M/dd/yyyy' }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Branch:
          </td>
          <td>{{ RepNamInfo.branchNumber }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Product Type:
          </td>
          <td>{{ RepNamInfo.productTypeDesc }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Sponsor:
          </td>
          <td>{{ RepNamInfo.sponsorName }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Transaction Type:
          </td>
          <td>{{ RepNamInfo.transactionTypeDesc }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Amount:
          </td>
          <td>
            {{ RepNamInfo.amount | currency : 'USD' : 'symbol' : '1.2-2' }}
          </td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Trans ID:
          </td>
          <td>{{ RepNamInfo.blotterId }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Principal Approval By:
          </td>
          <td>{{ approvalBy }}</td>
        </tr>
        <tr>
          <td style="text-align: left; width: 30%; white-space: nowrap;">
            Approval Date:
          </td>
          <td>{{ approvalDate | date : 'M/dd/yyyy' }}</td>
        </tr>
        <tr>
          <td colspan="2">&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2">
            This report serves as confirmation that the identified transaction
            was reviewed and approved by a Registered Principal of Capital
            Investment Group, Inc. or Capital Investment Brokerage, Inc.
          </td>
        </tr>
        <tr>
          <td colspan="2">&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2">
            If you have any questions, please contact our Compliance Department
            at (919) 831-2370
          </td>
        </tr>
      </table>
    </div>
    <hr />
    <p style="text-align:center; padding:15px;">
      <button
        kendoButton
        themeColor="primary"
        size="small"
        (click)="changeDeviceStatus()"
      >
        Download Pdf
      </button>
    </p>
    <!--  <hr><p style="float:right; margin-right:10px;"><button nbButton ="prstatusimary" size="tiny" onClick="printDiv('print-content')">Print</button></p> -->
  `,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      kendo-pdf-export {
        font-family: 'DejaVu Sans', 'Arial', sans-serif;
        font-size: 12px;
        background-color: #fff;
        color: #000;
      }
    `,
  ],
  imports: [
    KENDO_BUTTON,
    CurrencyPipe,
    DatePipe,
  ]
})
export class Pdfaccountreceipt {
  @ViewChild('contentTemplate') contentTemplate: TemplateRef<any>
  dialog: any
  public aftersubmit: boolean
  @Input() RepNamInfo: any
  private getBlotId: number
  public showcomment = false
  @Input() set blotterId(val: number) {
    this.getBlotId = val
    this.loadBlotterCommentData()
  }
  public Comments: any[] = []
  public approvalBy: string
  public approvalDate: Date
  public approvedByDate: Date
  constructor(
    private cliservice: ClientServices,
    private fx: FilterService,
    private dialogService: DialogService,
  ) { }

  loadBlotterCommentData() {
    const param = { blotId: this.getBlotId }
    this.cliservice
      .getAccountformReviewslist(param)
      .subscribe((response: any) => {
        this.approvalDate = response.modifiedDate
        this.approvalBy = response.modifiedBy
        const getcomments = (response ?? []).map((x) => x.comments)
        if (getcomments.toString() != '') {
          this.Comments = response
          this.showcomment = false
          return
        }
        this.showcomment = true
        return
      })
  }
  changeDeviceStatus(): void {
    this.aftersubmit = true
    this.fx.GetserviceaccountReports(this.getBlotId).subscribe((response) => {
      const url = window.URL.createObjectURL(response)
      const link = document.createElement('a')
      link.href = url
      link.download = `TransactionsReceipt.pdf`
      link.click()
      window.URL.revokeObjectURL(url)
    })
  }
  open(dialog: TemplateRef<any>) {
  this.dialogService.open({
    content: dialog,
    // you can still pass context if your template uses let-context
   // context: '',
    // you can also specify title, width, height, actions, etc.
    // title: 'My Dialog',
    // width: 500,
    // actions: [{ text: 'Close' }]
  });
}
 /*  open(dialog: TemplateRef<any>) {
    this.dialogService.open(dialog, {
      context: dialog,
    })
  } */
}
